import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-style-white',
  templateUrl: './wallet-style-white.component.html',
  styleUrls: ['./wallet-style-white.component.scss']
})
export class WalletStyleWhiteComponent {

}
